import React, { useState, useEffect } from 'react';
import { IProps, IFormValue } from './types';
import * as Yup from 'yup';
import { Formik, Form, Field } from 'formik';
import _ from 'lodash';
import { Secque, Occupation, OccupationContent, EmailDomain, Nationality, CountryContent, SysOption } from 'bff/models/info';
import { OccupationIdType } from 'constants/enums/occupationIdType.enum';
import { SignupGender } from 'constants/enums/signupGender.enum';
import { IdInfoType } from 'constants/enums/idInfoType.enum';
import { NationalType } from 'constants/enums/nationalType.enum';
import { MemberProfileTitle } from 'constants/enums/memberProfileTitle.enum';
import { SignupMembership } from 'constants/enums/signupMembership.enum';
import service from 'bff/services/memberProfileService';
import { AutoComplete, DatePicker } from 'formik-antd';
// import moment from 'moment';
import moment from 'moment-timezone';
import { CodeId } from 'constants/enums/codeId.enum';
import AddressComponent from 'components/AddressComponent';
import sweetAlertService from 'utils/sweetAlertService';
import InputWithRegex from 'components/InputWithRegex';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';
import commonService from 'utils/commonService';
import { mobileRegex, emailRegex } from 'utils/commonValidations';
import { Marriage } from 'constants/enums/marriage.enum';
import FormikFocusError from 'components/FormikFocusError';
import apiCommonService from 'bff/services/commonService';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { setMemberInfoErrorModalVisible, setRuleValidErrorModalVisible } from 'redux/actions/modal.action';
import MemberInfoErrorModal from 'components/MemberInfoErrorModal';
import { InfoCheckmailandmobileReq } from 'bff/models/info/infoCheckmailandmobile';

/** Form 表單初始值 */
let initialValues: IFormValue = {
  BIRTHDAY: '',
  HOME_TEL_AREA_CODE: '',
  HOME_TEL_NUMBER: '',
  MEMBERSHIP: [],
  STATUS: '1',
  ADDRESS: '',
  AREA_ID: '',
  AREA_NAME: '',
  CITY_ID: '',
  CITY_NAME: '',
  EMAIL_ADDR: '',
  EDM_SUBSCRIBE_TIME: undefined,
  GENDER: '',
  HEARING_DISABILITY: '',
  HOME_TELNO: '',
  MEMBER_ID: '',
  MOBILE: '',
  MARRIAGE: Marriage.Single,
  NAME: '',
  NATIONALITY_ID: '',
  NATIONALITY_TYPE: '',
  OCCUPATION_DESC: '',
  OCCUPATION_DOMAIN_ID: '',
  OCCUPATION_DOMAIN_ID_NAME: '',
  OCCUPATION_ID: '',
  OCCUPATION_ID_NAME: '',
  POST_CODE: '',
  SN: '',
  STAY_PERIOD: undefined,
  SECQUE_ID: '',
  SECQUE_QUESTION: '',
  SECQUE_ANSWER: '',
  OPERATOR: '',
  TOTAL_LOGIN_FAIL_COUNT: 0
};

/** 下拉選單的預設項目文字 */
const selectOptDefaultText = '請選擇';

/** 合理範圍的生日日期 */
// const validBirthDay = new Date(new Date().getFullYear() - 18, new Date().getMonth(), new Date().getDate());

const MemberProfileComponent: React.FC<IProps> = (props) => {
  const [nationalityType, setNationalityType] = useState('');
  /** 表單初始值 */
  const [initialVal, setInitialVal] = useState(initialValues);
  /** 表單檢核錯誤資訊 */
  const [initialError, setInitialError] = useState({} as Record<string, any>);
  /** 國籍資訊 */
  const [nationalType, setNationalType] = useState<string>();
  /** 職業類別資訊 */
  const [occupationId, setOccupationId] = useState<string>();
  /** 判斷是否訂閱通知 */
  const [edmSubscribe, setEdmSubscribe] = useState(false);
  /** 系統參數資料-GENDER、MARRIAGE */
  const [sysOpts, setSysOpts] = useState<{ genderSysOpts: SysOption[], marriageSysOpts: SysOption[] }>();
  /** 判斷是否有 ID 檢核錯誤 */
  const [memberIdError, setMemberIdError] = useState<string>('');
  /** 網域黑名單 */
  const [blockDomains, setBlockDomains] = useState<EmailDomain[]>([]);

  /** 抓取電子郵件欄位，限制輸入長度用 */
  const emailInput = document.getElementById('email-addr-input') as HTMLInputElement;

  // Validation Schema: 移入 Function Component 內，以取得 state 資料執行檢核
  const validationSchema = Yup.object().shape({
    MEMBER_ID: Yup.string().required('此為必填欄位').length(10, '帳號長度為 10 字元'),
    GENDER: Yup.string().required('此為必填欄位'),
    NAME: Yup.string()
      .required('此為必填欄位')
      .min(2, '姓名格式錯誤')
      .max(200, '姓名長度不可超過 200 字元')
      .test('contain num', '姓名格式不符', (val: string) => {
        if (val) {
          return !(/[\d]+/.test(val));
        }
        return true;
      }),
    BIRTHDAY: Yup.string().required('此為必填欄位').nullable(),
    MOBILE: Yup.string().required('此為必填欄位').length(10, '手機號碼長度為 10 字元').test('mobile format', '手機格式不符', (val: string) => {
      if (val) {
        return mobileRegex.test(val);
      }
      return true;
    }),
    HOME_TEL_AREA_CODE: Yup.string().min(2, '市話區碼最小長度為 2 字元').max(3, '市話區碼長度不可超過 3 字元'),
    HOME_TEL_NUMBER: Yup.string().max(8, '市話號碼長度不可超過 8 字元'),
    EMAIL_ADDR: Yup.string().required('此為必填欄位').matches(emailRegex, '電子信箱格式不符').email('電子信箱格式不符').max(50, '電子信箱長度不可超過 50 字元').test('block domain', commonService.getCodeMsg(props.UICode, CodeId.W087), (val: string) => {
      if (val && emailRegex.test(val)) {
        const snippets = val.split('@'); // 符合格式後進行拆分，以利檢核
        const isBlocked = blockDomains.find(it => it.EMAIL_DOMAIN_NAME === snippets[1]);
        if (isBlocked) return false;
      }
      return true;
    }),
    POST_CODE: Yup.string().required('此為必填欄位').max(6, '郵遞區號長度不可超過 6 字元'),
    CITY_ID: Yup.string().required('此為必填欄位'),
    AREA_ID: Yup.string().required('此為必填欄位'),
    ADDRESS: Yup.string().required('此為必填欄位').max(200, '詳細地址長度不可超過 200 字元'),
    NATIONALITY_ID: Yup.string().required('此為必填欄位'),
    HEARING_DISABILITY: Yup.string().required('此為必填欄位'),
    // 安全問題檢核調整 (2024/08/20)
    SECQUE_ID: Yup.string().test({
      name: 'secqueIdSchema',
      test: function (value) {
        const error = { message: '' };
        if (!value && this.parent.SECQUE_ANSWER) {
          error.message = '請於選擇安全問題後，填寫答案';
        }
        return error.message ? this.createError({ message: error.message }) : true;
      }
    }),
    SECQUE_ANSWER: Yup.string().test({
      name: 'secqueAnswerSchema',
      test: function (value) {
        const error = { message: '' };
        if (!value) {
          // 空值，則檢查問題是否已選擇
          if (this.parent.SECQUE_ID) {
            error.message = '請於選擇安全問題後，填寫答案';
          }
        } else {
          // 有值，則檢查長度
          if (value.length > 200) {
            error.message = '安全問題答案長度不可超過 200 字元';
          }
        }
        return error.message ? this.createError({ message: error.message }) : true;
      }
    }),
    OCCUPATION_DOMAIN_ID: Yup.string().required('此為必填欄位'),
    OCCUPATION_ID: Yup.string().when('OCCUPATION_DOMAIN_ID', (occupationId: OccupationIdType, schema: any) => {
      return occupationId && occupationId === OccupationIdType.Special ? schema.required('此為必填欄位') : schema;
    })
  });

  /**
   * @description 頁面初始
   */
  useEffect(() => {
    (async () => {
      // 取得網域黑名單
      const response = await apiCommonService.fetchBlockDomains();
      if (response) {
        setBlockDomains(response);
      }
    })();
  }, []);

  useEffect(() => {
    // 初始化取得系統參數
    async function initSysOpts () {
      const initSysOpts = await service.fetchSysOpts(props.applicationId);
      if (initSysOpts) setSysOpts(initSysOpts);
    }

    // 取得系統時間
    async function fetchSystime () {
      const serverTimeMs = await apiCommonService.fetchSysTime(props.applicationId);
      initialValues = {
        ...initialValues,
        AGREE_TIME_MA_PDP: serverTimeMs,
        REGISTER_TIME: serverTimeMs
      };
      setInitialVal(initialValues);
    }

    initSysOpts();
    fetchSystime();
    if (emailInput) {
      emailInput.setAttribute('maxlength', '50');
      emailInput.setAttribute('autocomplete', 'off');
    }
  }, [emailInput, props.applicationId]);

  useEffect(() => {
    initialValues = {
      ...initialValues,
      ...props.memberProfile,
      SECQUE_ID: props.memberProfile.SECQUE_ID ?? '',
      SECQUE_ANSWER: props.memberProfile.SECQUE_ANSWER ?? '',
      MARRIAGE: props.memberProfile.MARRIAGE ? props.memberProfile.MARRIAGE : Marriage.Single,
      BIRTHDAY: props.memberProfile.BIRTHDAY?.replace(/^([\d]{4})([\d]{2})([\d]{2})$/, '$1-$2-$3'),
      HOME_TEL_AREA_CODE: props.memberProfile.HOME_TELNO?.replace(/^(02|03|037|04|049|05|06|07|08|082|0826|0836|089)(.*)$/, '$1') || '',
      HOME_TEL_NUMBER: props.memberProfile.HOME_TELNO?.replace(/^(02|03|037|04|049|05|06|07|08|082|0826|0836|089)(.*)$/, '$2') || ''
    };
    setInitialVal(initialValues);
    setOccupationId(initialValues.OCCUPATION_DOMAIN_ID);
    setNationalType(initialValues.NATIONALITY_TYPE);
    setEdmSubscribe((props.memberProfile.EDM_SUBSCRIBE_TIME as number) > 0);
  }, [props.memberProfile]);

  useEffect(() => {
    if (props.notifyVal && !props.formLockup) {
      setInitialError({ MOBILE: '請重新確認正確性', EMAIL_ADDR: '請重新確認正確性' });
    }
  }, [props.formLockup, props.notifyVal]);

  useEffect(() => {
    const showModal = props.UICode && props.UICode.length > 0 && props.memberMaintain &&
      commonService.checkMemberInfoError(props.memberProfile);

    if (showModal) {
      props.setMemberInfoErrorModalVisible(true, '', commonService.getCodeMsg(props.UICode, CodeId.W066), ['MOBILE', 'EMAIL_ADDR']);
    }
  }, [props.memberMaintain, props.UICode, props]);

  // #region 會員資料帳號欄位的相關方法

  /**
   * @description 依會員帳號第 2 碼判斷性別，1、8 男性 2、9女性
   */
  const handleMemberIdChange = (event: React.ChangeEvent<HTMLInputElement>, setFieldValue: any) => {
    if (event.currentTarget.value.length > 0) {
      let nationalityType = '';
      switch (event.currentTarget.value[1]) {
        // 本國人男性
        case IdInfoType.NationalMale:
          setFieldValue('GENDER', SignupGender.Male);
          nationalityType = NationalType.National;
          break;
        // 本國人女性
        case IdInfoType.NationalFemale:
          setFieldValue('GENDER', SignupGender.Female);
          nationalityType = NationalType.National;
          break;
        // 外國人男性
        case IdInfoType.ForeignMale:
        case IdInfoType.ResidentMale:
        case IdInfoType.ResidentStatelessMale:
          setFieldValue('GENDER', SignupGender.Male);
          nationalityType = NationalType.Foreigner;
          break;
        // 外國人女性
        case IdInfoType.ForeignFemale:
        case IdInfoType.ResidentFemale:
        case IdInfoType.ResidentStatelessFemale:
          setFieldValue('GENDER', SignupGender.Female);
          nationalityType = NationalType.Foreigner;
          break;
        default:
          setFieldValue('GENDER', '');
          setFieldValue('NATIONALITY_TYPE', '');
          setFieldValue('NATIONALITY_ID', '');
          setNationalType('');
          nationalityType = '';
          commonService.setSelectOptName(setFieldValue, 'NATIONALITY_TYPE_NAME', '');
          commonService.setSelectOptName(setFieldValue, 'NATIONALITY_ID_NAME', '');
          break;
      }

      if (nationalityType) {
        setNationalityType(nationalityType);
        setDefaultNationality(nationalityType, setFieldValue);
      }
    }
  };

  /**
   * @description 取得國籍別
  */
  const handleGetNationalityType = (memberId: string) => {
    let nationalityType = '';
    if (memberId && memberId.length > 0) {
      switch (memberId[1]) {
        // 本國人
        case IdInfoType.NationalMale:
        case IdInfoType.NationalFemale:
          nationalityType = NationalType.National;
          break;
        // 外國人
        case IdInfoType.ForeignMale:
        case IdInfoType.ResidentMale:
        case IdInfoType.ResidentStatelessMale:
        case IdInfoType.ForeignFemale:
        case IdInfoType.ResidentFemale:
        case IdInfoType.ResidentStatelessFemale:
          nationalityType = NationalType.Foreigner;
          break;
        // 外國人女性
        default:
          nationalityType = '';
          break;
      }
    }
    return nationalityType;
  };

  /**
   * @description 帳號為本國人時預設國籍為 本國人、中華民國，帳號為外國人時設國籍為外國人
   */
  const setDefaultNationality = (nationalityType: string, setFieldValue: any) => {
    const nationality = _.find(props.nationalitys, (nationality: Nationality) => nationality.NATIONALITY_ID === nationalityType);
    if (nationality) {
      setNationalType(nationality.NATIONALITY_ID);
      setFieldValue('NATIONALITY_TYPE', nationality.NATIONALITY_ID);
      commonService.setSelectOptName(setFieldValue, 'NATIONALITY_TYPE_NAME', nationality.NATIONALITY_NAME);

      if (nationalityType === NationalType.National) {
        setFieldValue('NATIONALITY_ID', nationality.COUNTRY[0].COUNTRY_ID);
        commonService.setSelectOptName(setFieldValue, 'NATIONALITY_ID_NAME', nationality.COUNTRY[0].COUNTRY_NAME);
      }
    }
  };

  /**
   * @description 檢核帳號是否已存在格式是否正確
   */
  const handleValidID = _.debounce(async (val: any, setFieldError: any) => {
    if (props.memberMaintain) return '';
    if (val && val.length === 10) {
      const errorVal = await service.validateExistMemberId(val, props.applicationId);
      setFieldError('MEMBER_ID', errorVal);
      setMemberIdError(errorVal);
    }
  }, 500);

  // #endregion

  /**
   * @description 國籍別的 Change 事件
   */
  const handleNationalTypeChange = (event: React.ChangeEvent<HTMLSelectElement>, setFieldValue: any) => {
    setNationalType(event.target.value);
    commonService.setSelectOptName(setFieldValue, 'NATIONALITY_TYPE_NAME', event.currentTarget.selectedOptions.item(0)?.text);

    if (nationalType !== event.target.value) {
      setFieldValue('NATIONALITY_ID', '');
      commonService.setSelectOptName(setFieldValue, 'NATIONALITY_ID_NAME');
    };
  };

  /**
   * @description 職業類別的 Change 事件
   */
  const handleOccupationIdChange = (event: React.ChangeEvent<HTMLSelectElement>, setFieldValue: any) => {
    setOccupationId(event.target.value);
    commonService.setSelectOptName(setFieldValue, 'OCCUPATION_DOMAIN_ID_NAME', event.currentTarget.selectedOptions.item(0)?.text);

    if (!event.target.value || event.target.value === OccupationIdType.Special) {
      setFieldValue('OCCUPATION_ID', '');
      commonService.setSelectOptName(setFieldValue, 'OCCUPATION_ID_NAME');
    }

    if (event.target.value === OccupationIdType.Normal) {
      const occupation =
        _.find(props.occupations, (occupation: Occupation) => occupation.OCCUPATION_DOMAIN_ID === event.target.value);
      if (!occupation) return;
      setFieldValue('OCCUPATION_ID', occupation.OCCUPATION[0].OCCUPATION_ID);
      commonService.setSelectOptName(setFieldValue, 'OCCUPATION_ID_NAME');
    }
  };

  /**
   * @description 表單送出事件
   */
  const handleFormSubmit = async (formValues: IFormValue, action: any) => {
    // 手機與電子郵件檢核 (2024/04/02)
    const verifyRes = await verifyMailAndMobile(formValues);
    if (!verifyRes) return;

    let newMemberships = [...props.memberProfile.MEMBERSHIP];
    newMemberships = newMemberships.includes(SignupMembership.Normal) ? newMemberships : [...newMemberships, SignupMembership.Normal];

    formValues = {
      ...formValues,
      HOME_TELNO: `${formValues.HOME_TEL_AREA_CODE ? formValues.HOME_TEL_AREA_CODE : ''}${formValues.HOME_TEL_NUMBER ? formValues.HOME_TEL_NUMBER : ''}`,
      BIRTHDAY: moment(formValues.BIRTHDAY).format('YYYYMMDD'),
      EDM_SUBSCRIBE_TIME: edmSubscribe ? await apiCommonService.fetchSysTime() : undefined,
      MEMBERSHIP: [...newMemberships]
    };
    // // console.log('關閉會員資料檢核');
    // props.onFormSubmit(formValues);
    // // console.log('formValues', formValues);
    const checkErrorRes = await service.memberCheckfield({ ...formValues }, props.applicationId);
    if (Object.keys(checkErrorRes).length > 0) {
      // // console.log('checkErrorRes', checkErrorRes);
      // const errorMsg = _.map(Object.keys(checkErrorRes), (errorKey:any) => {
      //   return `${errorKey}:${checkErrorRes[errorKey]}\n`;
      // });
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        title: '參數格式錯誤'
        // html: errorMsg.join('<br />')
      });
      setInitialError({ ...checkErrorRes });
    } else {
      props.onFormSubmit(formValues);
    }
  };

  /**
   * @description 表單編輯事件
   */
  const handleFormEdit = async (formValues: IFormValue) => {
    // 手機與電子郵件檢核 (2024/04/02)
    // 點選編輯時，不檢核，儲存時檢核即可
    // const verifyRes = await verifyMailAndMobile(formValues);
    // if (!verifyRes) return;

    let newMemberships = [...props.memberProfile.MEMBERSHIP];
    newMemberships = newMemberships.includes(SignupMembership.Normal) ? newMemberships : [...newMemberships, SignupMembership.Normal];

    formValues = {
      ...formValues,
      HOME_TELNO: `${formValues.HOME_TEL_AREA_CODE ? formValues.HOME_TEL_AREA_CODE : ''}${formValues.HOME_TEL_NUMBER ? formValues.HOME_TEL_NUMBER : ''}`,
      BIRTHDAY: moment(formValues.BIRTHDAY).format('YYYYMMDD'),
      EDM_SUBSCRIBE_TIME: edmSubscribe ? await apiCommonService.fetchSysTime(props.applicationId) : undefined,
      MEMBERSHIP: [...newMemberships]
    };

    if (props.onFormEdit) props.onFormEdit(formValues);
  };

  /**
   * @description 手機與電子郵件檢核
   * @param values 表單值
   */
  const verifyMailAndMobile = async (values: IFormValue) => {
    const args: InfoCheckmailandmobileReq = {
      CHECKMAILANDMOBILE: [
        {
          SEQ: '01',
          NAME: values.NAME,
          MOBILE: values.MOBILE,
          MAIL: values.EMAIL_ADDR
        }
      ]
    };
    const response = await apiCommonService.validMailAndMobile(args, props.applicationId);
    if (!response) return false;
    if (response && response.CHECKMAILANDMOBILE) {
      if (response.CHECKMAILANDMOBILE.some(it => it.ISSUCCESS !== 'Y')) {
        const errorMsg: string[] = response.CHECKMAILANDMOBILE.filter(it => it.ISSUCCESS !== 'Y').map(it => it.MESSAGE);
        // 呈現多則檢核失敗
        props.setRuleValidErrorModalVisible(true, errorMsg);
        return false;
      }
    }
    // 檢核成功
    return true;
  };

  // #region 欄位錯誤變更 className 、 顯示錯誤訊息相關方法
  /**
   * @description 判斷欄位有無錯誤變更 className
   * @param errors formik 內建錯誤訊息物件
   * @param params 需檢核的欄位名稱
  */
  const handleGetColStyle = (touched: any, errors?: any, ...params: any) => {
    if ((Object.keys(initialError).length > 0 || Object.keys(errors).length > 0) && _.some(params, (paramName: string) => {
      return (errors[paramName] && touched[paramName]) || initialError[paramName];
    })) return 'element__form-group element__form-group--invalid';

    return 'element__form-group';
  };

  /**
    * @description 判斷欄位有無錯誤，顯示訊息
    * @param errors formik 內建錯誤訊息物件
    * @param params 需顯示的錯誤訊息
    */
  const handleGetErrorMsg = (touched: any, errors: any, ...params: any) => {
    if (Object.keys(errors).length > 0 || Object.keys(initialError).length > 0) {
      let paramName = _.find(params, (paramName: string) => errors[paramName]);
      if (paramName && touched[paramName]) {
        return errors[paramName];
      }

      paramName = _.find(params, (paramName: string) => initialError[paramName]);
      return initialError[paramName];
    }
  };
  // #endregion

  // #region 電子郵件相關方法，包含建立 Domain Name List

  /**
   * @description 取得電子信箱常用 Domain Name
   */
  const handleGetDomainSource = (val: string) => {
    const emailDNs: any = new Array(0);
    // 有輸入值，且尚未輸入 @ 呈現常用 Domain Name 選單
    if (val && val.indexOf('@') === -1) {
      _.map(props.emailDomains, (emailDomain: EmailDomain) => {
        emailDNs.push({ value: `${val}@${emailDomain.EMAIL_DOMAIN_NAME}` });
      });
    }
    return emailDNs;
  };

  // #endregion

  // #region 建立安全問題的下拉選單

  let secqueOpts: JSX.Element[];
  if (props.secques.length > 0) {
    secqueOpts = _.map(props.secques, (secque: Secque, index: number) => {
      return <option key={index} value={secque.SECQUE_ID}>{secque.SECQUE_QUESTION}</option>;
    });
  }

  // #endregion

  // #region 建立國籍的下拉選單

  let nationalityOtp: JSX.Element[];
  if (props.nationalitys.length > 0) {
    nationalityOtp = _.map(props.nationalitys, (nationality: Nationality, index: number) => {
      return <option key={index} value={nationality.NATIONALITY_ID}>{nationality.NATIONALITY_NAME}</option>;
    });
  }

  let countryOpt: JSX.Element[];
  if (nationalType) {
    const country = _.find(props.nationalitys, (nationality: Nationality) => nationality.NATIONALITY_ID === nationalType);

    if (country) {
      countryOpt = _.map(country.COUNTRY, (content: CountryContent, index: number) => {
        return <option key={index} value={content.COUNTRY_ID}>{content.COUNTRY_NAME}</option>;
      });
    }
  }

  // #endregion

  // #region 建立職業類別與職業項目的下拉選單

  let occupationIdOtp: JSX.Element[];
  if (props.occupations.length > 0) {
    occupationIdOtp = _.map(props.occupations, (occupation: Occupation, index: number) => {
      return <option key={index} value={occupation.OCCUPATION_DOMAIN_ID}>{occupation.OCCUPATION_NAME}</option>;
    });
  }

  let occupationContents: JSX.Element[];
  if (occupationId === OccupationIdType.Special || occupationId === OccupationIdType.Normal) {
    const occupation = _.find(props.occupations, (occupation: Occupation) => occupation.OCCUPATION_DOMAIN_ID === occupationId);

    if (occupation) {
      occupationContents = _.map(occupation.OCCUPATION, (content: OccupationContent, index: number) => {
        return <option key={index} value={content.OCCUPATION_ID}>{content.OCCUPATION_NAME}</option>;
      });
    }
  }

  // #endregion

  // #region 建立頁尾控制按鈕

  /**
   * @description 會員身分提示訊息區塊
   * @param info 提示訊息
   */
  // const getMemberInfo = (infoElemId: string, info: string) => {
  //   if (!infoElemId && !info) return null;
  //   return (
  //     <div className="member-profile-form__info" id={infoElemId}>
  //       <i className="member-profile-form__info-small-icon" />
  //       <div className="member-profile-form__info-block">
  //         <div className="member-profile-form__info-block-wrapper">
  //           <i className="member-profile-form__info-large-icon" />
  //           <p>{info}</p>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // };

  /**
   * @description 判斷會員身分是否已加入
   */
  const validMemberJoined = (membership: SignupMembership) => {
    return props.memberProfile.MEMBERSHIP?.indexOf(membership) !== -1
      ? <div className="member-profile-form__identity-status member-profile-form__identity-status--joined">已加入</div>
      : <div className="member-profile-form__identity-status">未加入</div>;
  };

  let memberShip: any;
  let controlBtn: JSX.Element;
  switch (props.title) {
    case MemberProfileTitle.Maintain:
      controlBtn = (
        <>
          <button type="submit" className="element__button element__button--red" disabled={props.formLockup}>儲存</button>
          <button type="button" className="element__button element__button--black" onClick={props.formLockup ? props.onGoBack : props.onCancel}>取消</button>
        </>
      );
      memberShip = (
        <>
          <div className="element__form-table-tr">
            <div className="element__form-table-td">
              <div className="element__form-group">
                <div className="element__form-group-title">會員身份</div>
                <div className="element__form-group-content">
                  <div className="member-profile-form__identity">
                    <div className="member-profile-form__identity-name">
                      <span>一般會員</span>
                      {/* {getMemberInfo('general-member-info', '請勾選同意加入app會員，或到「旺旺友聯app」下載並註冊。')} */}
                    </div>
                    {validMemberJoined(SignupMembership.Normal)}
                  </div>
                  <div className="member-profile-form__identity">
                    <div className="member-profile-form__identity-name">
                      <span>網路投保會員</span>
                    </div>
                    {validMemberJoined(SignupMembership.Web)}
                  </div>
                  {/* <div className="member-profile-form__identity">
                    <div className="member-profile-form__identity-name">
                      <span>line</span>
                      {getMemberInfo('line-member-info', commonService.getCodeMsg(props.tipCode, CodeId.T001))}
                    </div>
                    {validMemberJoined(SignupMembership.Line)}
                  </div>
                  <div className="member-profile-form__identity">
                    <div className="member-profile-form__identity-name">
                      <span>app</span>
                      {getMemberInfo('app-member-info', commonService.getCodeMsg(props.tipCode, CodeId.T002))}
                    </div>
                    {validMemberJoined(SignupMembership.App)}
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </>
      );
      break;
    case MemberProfileTitle.SignupStep:
      memberShip = null;
      controlBtn = (
        <>
          <button type="button" className="element__button element__button--red-border" onClick={props.onGoBack}>返回上一頁</button>
          <button type="submit" className="element__button element__button--red">下一步</button>
        </>
      );
      break;
  }

  // #endregion

  // #region 依系統參數資料產生 性別、婚姻狀況等區塊
  let genderArea: JSX.Element[];
  let marriageArea: JSX.Element[];
  if (sysOpts && (sysOpts.genderSysOpts.length > 0 || sysOpts.marriageSysOpts.length > 0)) {
    genderArea = _.map(sysOpts.genderSysOpts, (sysOpt: SysOption, index: number) => {
      return (
        <div className="element__radio-group" key={index}>
          <label htmlFor={`${sysOpt.PARAM_ID}-RADIO`}>
            <div className="element__radio">
              <Field type="radio" name="GENDER" id={`${sysOpt.PARAM_ID}-RADIO`} disabled value={sysOpt.PARAM_VALUE} />
              <div className="element__radio-btn" />
            </div>
            <span>{sysOpt.PARAM_TEXT}</span>
          </label>
        </div>
      );
    });

    marriageArea = _.map(sysOpts.marriageSysOpts, (sysOpt: SysOption, index: number) => {
      return (
        <div className="element__radio-group" key={index}>
          <label htmlFor={`${sysOpt.PARAM_ID}-RADIO`}>
            <div className="element__radio">
              <Field type="radio" name="MARRIAGE" disabled={props.formLockup || props.isFromLogin} id={`${sysOpt.PARAM_ID}-RADIO`} value={sysOpt.PARAM_VALUE} />
              <div className="element__radio-btn" />
            </div>
            <span>{sysOpt.PARAM_TEXT}</span>
          </label>
        </div>
      );
    });
  }

  // #endregion

  return (
    <div className="member-profile-form">
      <Formik
        initialValues={initialVal}
        initialErrors={initialError}
        validationSchema={validationSchema}
        onSubmit={handleFormSubmit}
        enableReinitialize
      >
        {({ errors, touched, setFieldError, setFieldValue, setFieldTouched, handleBlur, values, handleChange }) => (
          <Form onBlur={(e: any) => {
            if (initialError[e.target.name] || initialError[e.target.dataset.mixname]) {
              let initErrors = { ...initialError };
              const name = initialError[e.target.name] ? e.target.name : e.target.dataset.mixname;
              initErrors = {
                ...initErrors,
                [name]: ''
              };
              setInitialError(initErrors);
            }
          }}
          >
            <div className="member-profile-form__title">{props.title}</div>
            {(props.title === MemberProfileTitle.Maintain && props.onFormEdit && props.editBtnVisible) && (
              <div className="member-profile-form__edit-control">
                <button type="button" className="member-profile-form__edit-btn" onClick={() => handleFormEdit(values)}>編輯</button>
              </div>
            )}
            <div className="member-profile-form__content">
              <div className="element__form-table">
                <div className="element__form-table-tr">
                  <div className="element__form-table-td">
                    <div className={`${handleGetColStyle(touched, errors, 'MEMBER_ID')}`}>
                      <div className="element__form-group-title">帳號*</div>
                      {!props.formLockup ? (
                        <Field
                          type="text"
                          name="MEMBER_ID"
                          data-fieldname="MEMBER_ID"
                          tabIndex={1}
                          id="member-id-input"
                          className="element__input"
                          disabled={props.memberMaintain || props.isFromLogin}
                          placeholder="請輸入身份證字號/居留證號"
                          autoComplete="off"
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            handleMemberIdChange(e, setFieldValue);
                            const val = e.currentTarget.value ? e.currentTarget.value.toUpperCase() : e.currentTarget.value;
                            handleValidID(val, setFieldError);
                            setFieldTouched('MEMBER_ID', true);
                            handleChange('MEMBER_ID')(e);
                            setFieldValue('MEMBER_ID', val);
                          }}
                          validate={() => memberIdError}
                          maxLength={10}
                        />
                      ) : (
                        <input type="text" className="element__input" value={commonService.hiddenStringLastCharacter(values.MEMBER_ID, 5)} readOnly disabled />
                      )}
                      <div className="element__error-message">
                        {
                          handleGetErrorMsg(touched, errors, 'MEMBER_ID')
                        }
                      </div>
                    </div>
                  </div>
                  <div className="element__form-table-td">
                    <div className={`${handleGetColStyle(touched, errors, 'GENDER')}`}>
                      <div className="element__form-group-title">性別*</div>
                      <div className="element__form-group-content" data-fieldname="GENDER" tabIndex={2} style={{ outline: 'none' }}>
                        {genderArea}
                      </div>
                      <div className="element__error-message">
                        {
                          handleGetErrorMsg(touched, errors, 'GENDER')
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div className="element__form-table-tr">
                  <div className="element__form-table-td">
                    <div className={`${handleGetColStyle(touched, errors, 'NAME')}`}>
                      <div className="element__form-group-title">姓名*</div>
                      <Field type="text" name="NAME" data-fieldname="NAME" tabIndex={3} maxLength={200} autoComplete="off" placeholder="請輸入姓名" id="name-input" disabled={props.formLockup || props.isFromLogin} className="element__input" />
                      <div className="element__error-message">
                        {
                          handleGetErrorMsg(touched, errors, 'NAME')
                        }
                      </div>
                    </div>
                  </div>
                  <div className="element__form-table-td">
                    <div className={`${handleGetColStyle(touched, errors, 'BIRTHDAY')}`}>
                      <div className="element__form-group-title">生日* <span className="ant-picker-exam-info">範例： 20200101 (註冊會員需年滿18歲)</span></div>
                      <div className="element__form-group-content">
                        <DatePicker
                          className="element__input"
                          name="BIRTHDAY"
                          data-fieldname="BIRTHDAY"
                          tabIndex={4}
                          // defaultPickerValue={moment(validBirthDay)}
                          defaultPickerValue={moment().add(-18, 'y')}
                          showToday={false}
                          format="YYYYMMDD"
                          disabled={props.formLockup || props.isFromLogin}
                          disabledDate={(current: any) => {
                            // 會員生日
                            return current && (current > moment().add(-18, 'y') || current < moment('1911/01/01'));
                            // return current && (current > validBirthDay || current < moment('1911/01/01'));
                          }}
                          onChange={async e => {
                            if (e) {
                              const sysTime = Math.ceil(await apiCommonService.fetchSysTime() / 1000);
                              const nzTime = commonService.normalizeTime(e.format('YYYY-MM-DD'), sysTime);
                              setFieldValue('BIRTHDAY', nzTime);
                            }
                          }}
                        />
                      </div>
                      <div className="element__error-message">
                        {
                          handleGetErrorMsg(touched, errors, 'BIRTHDAY')
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div className="element__form-table-tr">
                  <div className="element__form-table-td">
                    <div className={`${handleGetColStyle(touched, errors, 'MOBILE')}`}>
                      <div className="element__form-group-title">手機號碼*</div>
                      {!props.formLockup ? (
                        <Field component={InputWithRegex} name="MOBILE" data-fieldname="MOBILE" tabIndex={5} id="mobile-input" autoComplete="off" maxLength={10} placeholder="0911222333" className="element__input" disabled={props.formLockup} />
                      ) : (
                        <input type="text" className="element__input" value={commonService.hiddenStringCharactersByIndexRange(values.MOBILE, 4, 7)} readOnly disabled />
                      )}
                      <div className="element__error-message">
                        {
                          handleGetErrorMsg(touched, errors, 'MOBILE')
                        }
                      </div>
                    </div>
                  </div>
                  <div className="element__form-table-td">
                    <div className={`${handleGetColStyle(touched, errors, 'HOME_TEL_AREA_CODE', 'HOME_TEL_NUMBER', 'HOME_TELNO')}`}>
                      <div className="element__form-group-title">住家電話</div>
                      <div className="element__form-group-content">
                        <Field component={InputWithRegex} data-mixname="HOME_TELNO" autoComplete="off" maxLength={3} name="HOME_TEL_AREA_CODE" id="home-tel-area-code-input" disabled={props.formLockup || props.isFromLogin} className="element__input" placeholder="02" />
                        <hr />
                        {!props.formLockup ? (
                          <Field component={InputWithRegex} data-mixname="HOME_TELNO" autoComplete="off" maxLength={8} name="HOME_TEL_NUMBER" id="home-tel-number-input" disabled={props.formLockup || props.isFromLogin} className="element__input" placeholder="11231212" />
                        ) : (
                          <input type="text" className="element__input" value={values.HOME_TEL_NUMBER ? commonService.hiddenStringCharactersByIndexRange(values.HOME_TEL_NUMBER, 2, 5) : values.HOME_TEL_NUMBER} placeholder="11231212" readOnly disabled />
                        )}
                      </div>
                      <div className="element__error-message">
                        {
                          handleGetErrorMsg(touched, errors, 'HOME_TEL_AREA_CODE', 'HOME_TEL_NUMBER', 'HOME_TELNO')
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div className="element__form-table-tr">
                  <div className="element__form-table-td">
                    <div className={`${handleGetColStyle(touched, errors, 'EMAIL_ADDR')}`}>
                      <div className="element__form-group-title">電子信箱*</div>
                      <AutoComplete
                        name="EMAIL_ADDR"
                        data-fieldname="EMAIL_ADDR"
                        tabIndex={6}
                        style={{ outline: 'none' }}
                        id="email-addr-input"
                        className={'element__antd-input' + (props.formLockup ? ' element__antd-input--disabled' : '')}
                        placeholder="請輸入電子信箱"
                        options={handleGetDomainSource(values.EMAIL_ADDR)}
                        disabled={props.formLockup}
                      />
                      <div className="element__error-message">
                        {
                          handleGetErrorMsg(touched, errors, 'EMAIL_ADDR')
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div className="element__form-table-tr">
                  <div className="element__form-table-td">
                    <div className={`${handleGetColStyle(touched, errors, 'POST_CODE', 'ADDRESS')}`}>
                      <div className="element__form-group-title">通訊地址*</div>
                      <div className="element__form-group-content">
                        <AddressComponent
                          postCodeName="POST_CODE"
                          postCodeId="post-code-input"
                          postCodeIdTabIndex={7}
                          cityIdName="CITY_ID"
                          cityId="city-id-select"
                          cityIdVal={values.CITY_ID}
                          cityIdText="CITY_NAME"
                          cityIdTabIndex={8}
                          areaIdName="AREA_ID"
                          areaId="area-id-select"
                          areaNameVal={values.AREA_NAME}
                          areaIdText="AREA_NAME"
                          areaIdTabIndex={9}
                          addressName="ADDRESS"
                          addressId="address-input"
                          addressVal={values.ADDRESS}
                          addressProtected={props.formLockup}
                          addressIdTabIndex={10}
                          postcodes={props.postcodes}
                          disabled={props.formLockup || props.isFromLogin}
                          handleBlur={handleBlur}
                          handleChange={handleChange}
                          setFieldValue={setFieldValue}
                        />
                      </div>
                      <div className="element__error-message">
                        {
                          handleGetErrorMsg(touched, errors, 'POST_CODE', 'CITY_ID', 'AREA_ID', 'ADDRESS')
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div className="element__form-table-tr">
                  <div className="element__form-table-td">
                    <div className={`${handleGetColStyle(touched, errors, 'NATIONALITY_ID')}`}>
                      <div className="element__form-group-title">國籍*</div>
                      <div className="element__form-group-content">
                        <Field
                          as="select"
                          // disabled={props.isFromLogin}
                          // disabled
                          disabled={nationalityType === NationalType.National}
                          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                            handleNationalTypeChange(e, setFieldValue);
                            handleChange('NATIONALITY_TYPE')(e);
                          }}
                          name="NATIONALITY_TYPE"
                          id="nationality-area-select"
                          className="element__select"
                          validate={(val: any) => {
                            const nationalityType = handleGetNationalityType(values.MEMBER_ID);
                            return val === nationalityType ? undefined : '帳號與國籍不符，請確認';
                          }}
                        >
                          <option value="">{selectOptDefaultText}</option>
                          {nationalityOtp}
                        </Field>
                        <Field
                          as="select" name="NATIONALITY_ID" data-fieldname="NATIONALITY_ID" tabIndex={11}
                          disabled={props.formLockup || props.isFromLogin} id="nationality-id-select" className="element__select" onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                            commonService.setSelectOptName(setFieldValue, 'NATIONALITY_ID_NAME', e.currentTarget.selectedOptions.item(0)?.text);
                            handleChange('NATIONALITY_ID')(e);
                          }}
                        >
                          <option value="">{selectOptDefaultText}</option>
                          {countryOpt}
                        </Field>
                      </div>
                      {errors.NATIONALITY_TYPE && touched.NATIONALITY_TYPE ? <div className="element__error-message">{errors.NATIONALITY_TYPE}</div> : null}
                      <div className="element__error-message">
                        {
                          handleGetErrorMsg(touched, errors, 'NATIONALITY_ID')
                        }
                      </div>
                    </div>
                  </div>
                  <div className="element__form-table-td">
                    <div className="element__form-group">
                      <div className="element__form-group-title">婚姻狀況</div>
                      <div className="element__form-group-content">
                        {marriageArea}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="element__form-table-tr">
                  <div className="element__form-table-td">
                    <div className={`${handleGetColStyle(touched, errors, 'OCCUPATION_DOMAIN_ID', 'OCCUPATION_ID')}`}>
                      <div className="element__form-group-title">職業類別*</div>
                      <div className="element__form-group-content">
                        <Field
                          as="select" name="OCCUPATION_DOMAIN_ID" data-fieldname="OCCUPATION_DOMAIN_ID" tabIndex={12} id="occupation-id-select" disabled={props.formLockup || props.isFromLogin} className="element__select" onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                            handleOccupationIdChange(e, setFieldValue);
                            handleChange('OCCUPATION_DOMAIN_ID')(e);
                          }}
                        >
                          <option value="">{selectOptDefaultText}</option>
                          {occupationIdOtp}
                        </Field>
                        <Field
                          as="select" name="OCCUPATION_ID" data-fieldname="OCCUPATION_ID" tabIndex={13} id="occupation-desc-select" className="element__select" onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                            commonService.setSelectOptName(setFieldValue, 'OCCUPATION_ID_NAME', e.currentTarget.selectedOptions.item(0)?.text);
                            handleChange('OCCUPATION_ID')(e);
                          }} disabled={occupationId !== OccupationIdType.Special || props.isFromLogin}
                        >
                          <option value="">{selectOptDefaultText}</option>
                          {occupationContents}
                        </Field>
                      </div>
                      <div className="element__error-message">
                        {
                          handleGetErrorMsg(touched, errors, 'OCCUPATION_DOMAIN_ID', 'OCCUPATION_ID')
                        }
                      </div>
                    </div>
                  </div>
                  <div className="element__form-table-td">
                    <div className={`${handleGetColStyle(touched, errors, 'HEARING_DISABILITY')}`}>
                      <div className="element__form-group-title">是否為聽障人士*</div>
                      <div className="element__form-group-content" data-fieldname="HEARING_DISABILITY" tabIndex={14} style={{ outline: 'none' }}>
                        <div className="element__radio-group">
                          <label htmlFor="hearing-disability-radio">
                            <div className="element__radio">
                              <Field type="radio" name="HEARING_DISABILITY" disabled={props.formLockup || props.isFromLogin} id="hearing-disability-radio" value="1" />
                              <div className="element__radio-btn" />
                            </div>
                            <span>是</span>
                          </label>
                        </div>
                        <div className="element__radio-group">
                          <label htmlFor="un-hearing-disability-radio">
                            <div className="element__radio">
                              <Field type="radio" name="HEARING_DISABILITY" disabled={props.isFromLogin} id="un-hearing-disability-radio" value="0" />
                              <div className="element__radio-btn" />
                            </div>
                            <span>否</span>
                          </label>
                        </div>
                      </div>
                      <div className="element__error-message">
                        {
                          handleGetErrorMsg(touched, errors, 'HEARING_DISABILITY')
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div className="element__form-table-tr">
                  <div className="element__form-table-td">
                    <div className={`${handleGetColStyle(touched, errors, 'SECQUE_ID', 'SECQUE_ANSWER')}`}>
                      <div className="element__form-group-title">安全問題</div>
                      <div className="element__form-group-content">
                        <Field
                          as="select" name="SECQUE_ID" data-fieldname="SECQUE_ID" tabIndex={15} id="secque-id-select" disabled={props.formLockup || props.isFromLogin} className="element__select" onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                            commonService.setSelectOptName(setFieldValue, 'SECQUE_QUESTION', e.currentTarget.selectedOptions.item(0)?.text);
                            handleChange('SECQUE_ID')(e);
                          }}
                        >
                          <option value="">{selectOptDefaultText}</option>
                          {secqueOpts}
                        </Field>
                        {!props.formLockup ? (
                          <Field type="text" maxLength={200} autoComplete="off" name="SECQUE_ANSWER" data-fieldname="SECQUE_ANSWER" tabIndex={16} disabled={props.formLockup || props.isFromLogin} className="element__input" placeholder="請輸入答案" />
                        ) : (
                          <input type="text" className="element__input" value={commonService.hiddenStringCharacters(values.SECQUE_ANSWER)} readOnly disabled />
                        )}
                      </div>
                      <div className="element__error-message">
                        {
                          handleGetErrorMsg(touched, errors, 'SECQUE_ID', 'SECQUE_ANSWER')
                        }
                      </div>
                    </div>
                  </div>
                </div>
                {memberShip}
                <div className="element__form-table-tr">
                  <div className="element__form-table-td">
                    {/*
                    <div className="element__checkbox-group">
                      <label htmlFor="app-auth-checkbox">
                        <div className="element__checkbox">
                          <input
                            disabled={(props.memberMaintain && joinedApp) || props.isFromLogin}
                            type="checkbox"
                            name="MEMBERSHIP"
                            id="app-auth-checkbox"
                            checked={joinedApp}
                            onChange={(e:React.ChangeEvent<HTMLInputElement>) => setJoinedApp(e.currentTarget.checked)}
                          />
                          <div className="element__checkbox-btn" />
                        </div>
                        <span>{commonService.getCodeMsg(props.UICode,CodeId.U015)}</span>
                      </label>
                    </div>
                    */}
                    {
                      props.memberMaintain && (
                        <div className="element__checkbox-group">
                          <label htmlFor="receive-information-checkbox">
                            <div className="element__checkbox">
                              <input
                                type="checkbox"
                                name="EDM_SUBSCRIBE"
                                disabled={props.formLockup || props.isFromLogin}
                                id="receive-information-checkbox"
                                checked={edmSubscribe}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                  setEdmSubscribe(e.currentTarget.checked);
                                }}
                              />
                              <div className="element__checkbox-btn" />
                            </div>
                            <span>{commonService.getCodeMsg(props.UICode, CodeId.U016)}</span>
                          </label>
                        </div>
                      )
                    }
                  </div>
                </div>
              </div>
            </div>
            <div className="member-profile-form__controls">
              {controlBtn}
            </div>
            <FormikFocusError />
            <MemberInfoErrorModal />
          </Form>
        )}
      </Formik>
    </div>
  );
};

MemberProfileComponent.defaultProps = {
  formLockup: false
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setRuleValidErrorModalVisible: (visible: boolean, errorMsgs: string[]) => dispatch(setRuleValidErrorModalVisible(visible, errorMsgs)),
  setMemberInfoErrorModalVisible: (visible: boolean, title?: string, content?: string, fieldNames?: string[]) => dispatch(setMemberInfoErrorModalVisible(visible, title, content, fieldNames))
});

export default connect(null, mapDispatchToProps)(MemberProfileComponent);
